import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {CustomerGridItemModel} from "../../../../pages/administration/customers/customer.models";
import {BasePopupProps} from "../../../../utils/Models";
import FlintLoadingWrapper from "../../common/loading/FlintLoadingWrapper";
import FlintGridWrapper from "../../grid/FlintGridWrapper";
import {ApiUrl_Customers_CustomerListForUser_Read} from "../../../../utils/Endpoints";
import {GridColumn} from "@progress/kendo-react-grid";
import GridSearchBox from "../../../page_elements/orders/GridSearchBox";
import {actionColumn} from "../../grid/GridActionColumnCell";
import {VivoPortal} from "../../../../utils/AppConstants";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;


export default function CompanyListForUserComponent(props: CompanyListForUserProfileProps) {
    const {t} = useTranslation();
    const {state, utils, handlers} = useCompanyListForUserProfile(props);
    const actionColumns: actionColumn[] = [
        {
            type:EnumIconButtonDefaultType.Select, onClick: (company) => {
                handlers.handleCompanySelected(company);
            }
        }
    ];

    return (
        <FlintLoadingWrapper showLoading={state.isLoading.get}>
            <div className={"mt-2"}>
                <GridSearchBox onSearch={(x) => {
                    handlers.handleSearch(x);
                }}/>
            </div>
            <FlintGridWrapper<CustomerGridItemModel>
                pageTitle={null}
                //headerNode={}
                apiUrl={ApiUrl_Customers_CustomerListForUser_Read}
                requestParameters={state.filter.get}
                gridRefreshTrigger={state.gridRefreshTrigger.get}
                actionColumns={actionColumns}
                //onRowClicked={handlers.handleCompanySelected}
            >
                <GridColumn title={"Country Code"}
                            field={"CountryMnemonic"} width={100}/>
                <GridColumn title="Id" field="Id" width={100}/>
                <GridColumn title="Customer" field="Name"/>
            </FlintGridWrapper>
        </FlintLoadingWrapper>
    );
}

export interface CompanyListForUserProfileProps extends BasePopupProps<CustomerGridItemModel> {
    LabId: number;
    DivisionId: number;
}

function useCompanyListForUserProfile(props: CompanyListForUserProfileProps) {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [textFilter, setTextFilter] = useState<string | undefined>();
    const [gridRefreshTrigger, setGridRefreshTrigger] = useState<number>(0);
    const [filter, setFilter] = useState<{
        LabId: number;
        DivisionId: number;
        TextFilter?: string;
    }>({LabId: props.LabId, DivisionId: props.DivisionId});

    useEffect(() => {
        setGridRefreshTrigger(gridRefreshTrigger + 1);
    }, [filter]);

    function handleSearch(search?: string): void {
        if (search == textFilter)
            return;
        setTextFilter(search);
        setFilter(prev => ({
            ...prev,
            TextFilter: search
        }));
    }

    function handleCompanySelected(company: CustomerGridItemModel) {
        props.OnConfirmedAndSaved(company);
    }

    return {
        state: {
            isLoading: {get: isLoading, set: setIsLoading},
            textFilter: {get: textFilter},
            filter: {get: filter},
            gridRefreshTrigger: {get: gridRefreshTrigger},
        },
        utils: {
            visibility: {},
        },
        handlers: {
            handleSearch,
            handleCompanySelected,
        },
    };
}
